import React from "react";
import get from "lodash/get";
import { object, number, array } from "prop-types";
import { Link } from "@quintype/components";

import Headline from "../../atoms/headline";
import CardImage from "../../atoms/card-image";
import PlaceholderImage from "../../atoms/placeholder-image";

import "./card-image-type-5.m.css";

const CardImageType5 = ({ story, headlineLimit, widths = [250, 480, 764] }) => {
  const storyObj = story.story ? story.story : story;
  const slug = storyObj["hero-image-s3-key"];
  const storyImageSlug = get(storyObj, ["alternative", "home", "default", "hero-image", "hero-image-s3-key"], slug);

  return (
    <Link href={`/${storyObj.slug}`}>
      <div styleName="wrapper" className="card-image-type-5">
        {storyImageSlug ? (
          <CardImage story={storyObj} aspectRatio={[267, 332]} imageType="image267x332" widths={widths} />
        ) : (
          <PlaceholderImage aspectRatio={"267x332"} className="placeholder-image" story={storyObj} />
        )}
        <Headline story={storyObj} headerType={2} headerLevel={2} headlineLimit={headlineLimit} />
      </div>
    </Link>
  );
};

export default CardImageType5;

CardImageType5.propTypes = {
  story: object,
  headlineLimit: number,
  widths: array
};
